import Banner from './banner';
import Filters from './main/filters';
import SortBy from './main/filters/SortBy';
import Grid from './main/products/grid';
import MobileFilters from './main/filters/MobileFilters';
import BrandsFilter from './main/filters/BrandsFilter';
import Breadcrumb from './breadcrumb';
import SeoSection from './main/SeoSection';
import Metadata from './Metadata';
import CollectionMarketplace from './main/CollectionMarketplace';

const CollectionPageLayout = () => (
  <>
    <Metadata />
    <div className="bg-white text-sm">
      {/* Breadcrumb: Used for Category Collection Pages */}
      <Breadcrumb />
      {/* Banner */}
      <Banner />
      <div
        className="xl:reebelo-container mx-auto px-5 xl:px-8"
        id="collection-page"
      >
        {/* Content */}
        <div className="grid grid-cols-1 items-start gap-x-4 lg:grid-cols-12">
          {/* Filters Section */}
          <section className="relative col-span-4 hidden rounded border border-gray-500 lg:block xl:col-span-3">
            <Filters />
          </section>
          {/* Products Section */}
          <section className="flex flex-col gap-y-2 lg:col-span-8 lg:gap-y-4 xl:col-span-9">
            <div className="relative flex items-center">
              <MobileFilters />
              <div className="flex w-full flex-1 items-center justify-end gap-x-4">
                <BrandsFilter className="hidden w-full lg:flex" />
                <SortBy className="w-full md:relative lg:w-auto" />
              </div>
            </div>
            <BrandsFilter className="lg:hidden" />
            <Grid />
          </section>
        </div>
      </div>
      <CollectionMarketplace />
      <SeoSection />
    </div>
  </>
);

export default CollectionPageLayout;
